import _ from 'lodash';
import { CKForm, enums } from 'console-kit';
import { put, select } from 'redux-saga/effects';

import ConsoleAppActions from '../../App/redux/app-actions';

/**
 * Preparing the errors array to output unique only and exitent validation errors
 */
export const extractFormErrors = (errors) =>
  _.uniq(_.flattenDeep(_.filter(_.values(errors), (value) => !_.isEmpty(value))));

/**
 * Validates the given formId. When invalid, it will show the invalid message.
 * @param {*} formId - id of the form we want to validate
 * @param {*} messageType - messageType to show when the form is invalid
 * @param {*} header - invalid message header
 * @returns true/false showing if the form is valid or not
 */
export function* validateForm({
  formId,
  messageType = enums.messageTypes.WARNING,
  header = 'The form has invalid fields.',
}) {
  yield put(CKForm.Actions.validateForm(formId));
  const isFormValid = yield select(CKForm.Selectors.isFormValid, formId);
  if (!isFormValid) {
    const errors = yield select(CKForm.Selectors.getFormErrors, formId),
      fieldsWithErrors = extractFormErrors(errors).join('<br />');
    yield put(
      ConsoleAppActions.setAlertMessage({
        messageType,
        header,
        byline: fieldsWithErrors,
      })
    );
  }
  return isFormValid;
}

export default {
  extractFormErrors,
  validateForm,
};
